export default __webpack_public_path__ + "static/img_9-cca43ea32925b29b7f2cdfc73d15d307.png";